module.exports = __webpack_public_path__ + "img/edge_nature_route.599acb02.svg";